import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master.service';
import { HtmlPolicy } from 'src/app/models/master/html-policy.model';
import { Subject, Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'src/app/services/common.service';
import { CreditLineFNB } from 'src/app/models/account/credit-line-fnb.model';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { JsonResult } from 'src/app/core/json-result.model';
import { HtmlPolicyToTV } from 'src/app/models/master/html-policy-to-tv.model';

@Component({
  selector: 'app-virtual-store-footer',
  templateUrl: './virtual-store-footer.component.html',
  styleUrls: ['./virtual-store-footer.component.scss']
})
export class VirtualStoreFooterComponent implements OnInit {
  policies: HtmlPolicy[] = [];
  accountDataFetchedSubscription: Subscription;
  creditLineFNB: CreditLineFNB = new CreditLineFNB();
  unsubscribe$ = new Subject();

  constructor(private masterService: MasterService, private domSanitizer: DomSanitizer,
              private commonService: CommonService,
              private authService: AuthService) {
    this.accountDataFetchedSubscription = this.commonService.accountDataFetchedAnnounced
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(accountData => {
      this.creditLineFNB = this.authService.getCreditLineFNB();
      this.loadPolicies();
    });
  }

  ngOnInit() {
  }

  loadPolicies(): any {
    this.policies = [];
    if(this.creditLineFNB.isCreditLineFNB) {
      this.masterService.getHtmlPolicyFNBToTV().subscribe(
        response => {
          this.assignPolices(response);
        }
      );
    } else {
      this.masterService.getHtmlPolicyGSDToTV().subscribe(
        response => {
          this.assignPolices(response);
        });
    }
  }

  assignPolices(response: JsonResult<HtmlPolicyToTV>) {
    if (response.valid && !response.warning) {
      this.policies.push({
        title: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicyDelivery.title),
        body: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicyDelivery.body)
      });
      this.policies.push({
        title: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicySales.title),
        body: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicySales.body)
      });
      this.policies.push({
        title: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicyInstallation.title),
        body: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicyInstallation.body)
      });
      this.policies.push({
        title: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicyWarranty.title),
        body: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicyWarranty.body)
      });
      this.policies.push({
        title: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicyReturn.title),
        body: this.domSanitizer.bypassSecurityTrustHtml(response.data.htmlPolicyReturn.body)
      });
    }
  }
}
